import { render, staticRenderFns } from "./kprelease.vue?vue&type=template&id=856ea3dc&scoped=true&"
import script from "./kprelease.vue?vue&type=script&lang=ts&"
export * from "./kprelease.vue?vue&type=script&lang=ts&"
import style0 from "./kprelease.vue?vue&type=style&index=0&id=856ea3dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856ea3dc",
  null
  
)

export default component.exports